import { createAxiosInstance } from './http';

export async function getPageBySlug(slug) {
  const res = await createAxiosInstance().get(`/pages/${encodeURIComponent(slug)}`);
  return res.data?.data || res.data;
}

